import { CircularProgress } from "@mui/material";

const ProgressLoader = (props: any) => (
  <CircularProgress {...props} />
);

export default ProgressLoader;
